import { useQuery } from '@tanstack/react-query';
import type { VehicleByRegistrationNumberMinimal } from '@//app/api/protected/vehicle/lookup/registration-number/[registrationNumber]/minimal';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetJson } from '../httpClient';

export const VEHICLE_BY_REGISTRATION_NUMBER_MINIMAL_RATE_LIMITED_CACHE_KEY =
  'api/vehicle/lookup/registration-number/:registrationNumber/minimal';

const useVehicleByRegistrationNumberMinimalRateLimited = (registrationNumber?: string) => {
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<VehicleByRegistrationNumberMinimal>({
    queryKey: [VEHICLE_BY_REGISTRATION_NUMBER_MINIMAL_RATE_LIMITED_CACHE_KEY, registrationNumber],
    queryFn: async () => {
      const url = `${apiBaseUrl}/api/vehicle/lookup/registration-number/${registrationNumber}/minimal`;
      return await httpClientGetJson<VehicleByRegistrationNumberMinimal>(url);
    },
    enabled: !!registrationNumber,
  });

  return query;
};

export default useVehicleByRegistrationNumberMinimalRateLimited;
